import { baseApi } from '../apiProvider';
import { ResponseCategory } from '../models/response/responseCategory';
import {
  ResponseEvent,
  ResponsePrivateEvent,
} from '../models/response/responseEvent';

const eventAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get event categories
    getEventCategoryList: builder.query<Array<ResponseCategory>, void>({
      query: () => ({
        url: `/v0/event-categories`,
        method: 'GET',
      }),
    }),
    // get event list
    getEventList: builder.query<Array<ResponseEvent>, void>({
      query: () => ({
        url: `/v0/events?isRunning=true`,
        method: 'GET',
      }),
    }),
    // get event list
    getAvailableEventList: builder.query<Array<ResponseEvent>, void>({
      query: () => ({
        url: `/v0/events/published`,
        method: 'GET',
      }),
    }),
    // get event list
    getPrivateEvents: builder.mutation<Array<ResponsePrivateEvent>, string>({
      query: (id: string) => ({
        url: `/v0/private-events/users/${id}`,
        method: 'GET',
      }),
    }),
    getJoinableEventList: builder.query<Array<ResponseEvent>, void>({
      query: () => ({
        url: `/v0/events/joinable`,
        method: 'GET',
      }),
    }),
    getEventInfo: builder.mutation<ResponseEvent, string>({
      query: (eventId: string) => ({
        url: `/v0/events/${eventId}`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetEventCategoryListQuery,
  useGetEventListQuery,
  useGetJoinableEventListQuery,
  useGetAvailableEventListQuery,
  useGetPrivateEventsMutation,
  useGetEventInfoMutation,
} = eventAPI;
